import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Form,
  Row,
  Col,
  Button,
  Card,
  Container,
  ToggleButtonGroup,
  ToggleButton,
} from "react-bootstrap";
import { toast } from "react-toastify";
import WebService from "../../Services/WebService";
import { Label } from "../Common/Label/Label";
import PageLoader from "../Common/Loader/PageLoader";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import CompoLoader from "../Common/ComponentLoader/CompoLoader";
import { PiCaretLeftBold } from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";
import { addOrganization, profileSettings } from "../../config/action";

const SelectOrganization = () => {
  let dispatch = useDispatch();
  const [orgList, setOrgList] = useState<any[]>([]);
  let navigate = useNavigate();
  const [section, setSection] = useState("First");
  const [newOrgFlag, setOrgFlag] = useState(false);
  const [key, setKey] = useState(Math.random());

  const [loader, setLoader] = useState(false);
  const [addLoader, setAddLoader] = useState(false);
  const [selectedOrgUUID, setSelectedOrgUUID] = useState<string | null>(localStorage.getItem("org_uuid"));

  const profileDetails = useSelector(
    (state: any) => state?.profile?.profile_setting
  );
  let companyObject = {
    id: "",
    uuid: "",
    name: "",
    email: profileDetails?.email,
    dial_code: "+91",
    country_code: "in",
    mobile_number: profileDetails?.mobile_number,
  };
  const [company, setCompany] = useState<any>(companyObject);

  useEffect(() => {
    getOrganizationList();
  }, []);

  const getOrganizationList = () => {
    setLoader(true);
    return WebService.getAPI({
      action: `user-organization`,
      body: null,
      isShowError: true,
    })
      .then((res: any) => {
        setOrgList(res?.list);
        if (res?.list?.length > 0) {
          const firstActiveItem = res?.list.find((item: any) => item.subscription_status !== 'INACTIVE');
          if (firstActiveItem) {
            localStorage.setItem("org_uuid", firstActiveItem.uuid);
            localStorage.setItem("organization", firstActiveItem.name);
            setSelectedOrgUUID(firstActiveItem.uuid);
          }
        }
        setLoader(false);
      })
      .catch((error: any) => {
        setLoader(false);
        return error;
      });
  };
  const goBack = () => {
    setCompany(companyObject);
    setSection("First");
  };
  const handleSaveNewOrganization = () => {
    if (
      company?.name === ""
      //  ||
      // company?.email === "" ||
      // !HelperService.validateEmail(company?.email) ||
      // company?.mobile_number === ""
    ) {
      setOrgFlag(true);
      return;
    } else {
      setOrgFlag(false);
    }

    console.log(company, "company");
    setAddLoader(true);
    WebService.addLoader("add-new");
    return WebService.postAPI({
      action: `organization`,
      body: company,
      isShowError: true,
    })
      .then((res: any) => {
        toast.success(res.message);
        getOrganizationList();
        setSection("First");
        setCompany(companyObject);
        WebService.removeLoader("add-new");
        setAddLoader(false);
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        WebService.removeLoader("add-new");
        setAddLoader(false);
        return error;
      });
  };
  // const handleUpdateOrganization = () => {
  //   if (
  //     company?.name === ""
  //     // ||
  //     // company?.email === "" ||
  //     // company?.email === null ||
  //     // !HelperService.validateEmail(company?.email) ||
  //     // company?.mobile_number === "" ||
  //     // company?.mobile_number === null
  //   ) {
  //     setOrgFlag(true);
  //     return;
  //   } else {
  //     setOrgFlag(false);
  //   }

  //   setAddLoader(true);
  //   WebService.addLoader("add-new");
  //   return WebService.putAPI({
  //     action: `organization/${selectedOrgUUID}`,
  //     body: company,
  //     isShowError: true,
  //   })
  //     .then((res: any) => {

  //       toast.success(res.message);
  //       getOrganizationList();
  //       setSection("First");
  //       setCompany(companyObject);
  //       meCall("");
  //       WebService.removeLoader("add-new");
  //       setAddLoader(false);
  //     })
  //     .catch((error: any) => {
  //       toast.error(error?.response?.data?.message);
  //       WebService.removeLoader("add-new");
  //       setAddLoader(false);
  //       return error;
  //     });
  // };

  const getSubscriptionStatus = () => {
    if (
      !selectedOrgUUID ||
      (profileDetails?.organizations &&
        profileDetails?.organizations?.length > 0 &&
        profileDetails?.organizations[0]?.id) === selectedOrgUUID
    ) {
      navigate("/dashboard");
      return;
    }

    return WebService.getAPI({
      action: `subscription-status`,
      body: null,
      isShowError: false,
    })
      .then((res: any) => {
        // if (
        //   res?.user_type === "SUPER_ADMIN_EMPLOYEE" ||
        //   res?.user_type === "SUPER_ADMIN"
        // ) {

        // return;
        // }
        if (res?.status === "success") {

          if (res?.plan_status === "PENDING" && res?.have_subscription === true) {
            navigate("/request-sent");
            return;
          } else {
            localStorage.setItem("active_menu", "Dashboard");
            navigate("/dashboard");
          }
        } else {
          toast.error(res.message)
        }
      })
      .catch((error: any) => {
        return error;
      });
  };

  const meCall = (type: any) => {
    WebService.addLoader("dashboard-btn");
    return WebService.getAPI({
      action: `me/${selectedOrgUUID}`,
      body: null,
      isShowError: true,
    })
      .then((res: any) => {
        let tempArray: any = [];
        res?.info?.organizations.forEach((obj: any) => {
          let values = {
            label: res?.info?.organizations?.name,
            value: res?.info?.organizations?.id,
          };
          tempArray.push(values);
        });

        localStorage.setItem("user_id", res?.info?.id);
        dispatch(addOrganization(tempArray));
        dispatch(profileSettings(res?.info));
        localStorage.setItem("login_type", res?.info?.login_type);
        localStorage.setItem("user_mode", res?.info?.user_type?.user_type);
        getSubscriptionStatus();
        if (type === "plan") {
          localStorage.setItem("active_menu", "Dashboard");
          // navigate("/dashboard");
          WebService.removeLoader("dashboard-btn");
        }
      })
      .catch((error: any) => {
        WebService.removeLoader("dashboard-btn");
        return error;
      });
  };
  ;
  return (
    <>
      {loader ? (
        <PageLoader />
      ) : (
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} className="mx-auto">
              {section === "First" ? (
                <Card className="login-card card-style p-4">
                  <div className=" ">
                    <div className="text-center mb-4 mb-lg-5">
                      <h1 className="mb-2 font-semibold font-18">
                        Select Organization
                      </h1>
                    </div>

                    <div className="">
                      <Form className="form-style">
                        <ToggleButtonGroup
                          type="radio"
                          name="AccountMode"
                          className="radio-card-option"
                          onChange={() => { }}
                          value={""}
                        // value={selectedAccountMode}
                        // onChange={handleAccountModeChange}
                        >
                          {orgList && orgList.length > 0
                            ? orgList.map((org: any, index: any) => {
                              return (
                                <ToggleButton
                                  key={org.value}
                                  id={`tbg-btn-1_${org.id}`}
                                  value={org.id}
                                  className="btn btn-outline-light mb-2"
                                >
                                  <div
                                    key={index}
                                    className="d-flex justify-content-between"
                                  >

                                    <Form.Check
                                      type={"radio"}
                                      checked={selectedOrgUUID === org.uuid}

                                      id={`default-radio_${index}`}
                                      label={org.name}
                                      disabled={org.subscription_status === 'INACTIVE'}
                                      name={"org"}
                                      className="font-16 me-3"
                                      onChange={() => {
                                        localStorage.setItem("org_uuid", org.uuid);
                                        localStorage.setItem("organization", org.name);
                                        setSelectedOrgUUID(org.uuid);
                                      }}
                                    />
                                    {/* <AiTwotoneEdit
                                        className="cursor-pointer"
                                        size={20}
                                        onClick={() => {
                                          setSelectedId(org.uuid);
                                          getOrgDetails(org.uuid);
                                        }}
                                      /> */}
                                  </div>
                                </ToggleButton>
                              );
                            })
                            : ""}
                        </ToggleButtonGroup>
                        <div className="d-flex justify-content-between mt-4">
                          {" "}
                          <Button
                            className="btn btn-brand me-1"
                            id="dashboard-btn"
                            onClick={() => {
                              meCall("plan");
                              // getSubscriptionStatus();
                            }}
                          >
                            Go To Dashboard
                          </Button>
                          {orgList?.length < 5 ? (
                            <Button
                              className="btn btn-brand ms-1"
                              id="verify"
                              onClick={() => {
                                setSelectedOrgUUID("");
                                setSection("Second");
                              }}
                            >
                              + Add New Organization
                            </Button>
                          ) : (
                            <label className="font-16 text-danger font-bold">
                              {" "}
                              Maximum 5 organizations can be added in one
                              account
                            </label>
                          )}
                        </div>
                      </Form>
                    </div>
                  </div>
                </Card>
              ) : (
                section === "Second" && (
                  <Form className="form-style">
                    <Card className="login-card card-style">
                      <Card.Header className=" ">
                        <div className="d-flex gap-2 align-items-center">
                          <button
                            className="btn header-nav-btn"
                            onClick={goBack}
                          >
                            <PiCaretLeftBold size={16} />
                          </button>

                          <h2 className="page-title mb-0">
                            {selectedOrgUUID === "" ? "Add Company" : "Edit Company"}
                          </h2>
                        </div>
                        {/* <h1 className="font-semibold font-18">Add Company</h1> */}
                      </Card.Header>
                      <Card.Body>
                        <Row className=" position-relative">
                          {addLoader ? <CompoLoader /> : null}
                          <Col lg={6}>
                            <Form.Label className="required font-semibold font-14">
                              Company Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              id="name"
                              name="name"
                              value={company?.name}
                              placeholder="Enter Company Name"
                              onChange={(e: any) => {
                                setCompany((prev: any) => ({
                                  ...prev,
                                  name: e.target.value,
                                }));
                              }}
                            />
                            {newOrgFlag && company?.name === "" && (
                              <Label
                                title="Please enter company name"
                                modeError={true}
                              ></Label>
                            )}
                          </Col>
                          <Col lg={6}>
                            <Form.Label className="required font-semibold font-14">
                              Contact Email
                            </Form.Label>
                            <Form.Control
                              type="text"
                              id="email"
                              value={profileDetails?.email}
                              name="email"
                              placeholder="Enter Email"
                            // onChange={(e: any) => {
                            //   setCompany((prev: any) => ({
                            //     ...prev,
                            //     email: e.target.value,
                            //   }));
                            // }}
                            />
                            {/* {(!HelperService.validateEmail(company?.email) ||
                              company?.email === "") &&
                              newOrgFlag && (
                                <Label
                                  title="Please enter valid email"
                                  modeError={true}
                                ></Label>
                              )} */}
                          </Col>
                          <Col lg={6} className="mt-2">
                            <Form.Label className="required font-semibold font-14">
                              Contact Mobile Number
                            </Form.Label>
                            <PhoneInput
                              key={key}
                              country={company?.country_code}
                              disabled
                              value={
                                profileDetails?.dial_code
                                  ? `${profileDetails.dial_code}${profileDetails.mobile_number}`
                                  : `+91${profileDetails?.mobile_number}`
                              }
                            // onChange={(phone, country: any) => {
                            //   let mobile = removeDialCodeFromMobile(
                            //     phone,
                            //     country.dialCode
                            //   );
                            //   setCompany((prev: any) => ({
                            //     ...prev,
                            //     dial_code: country?.dialCode,
                            //     mobile_number: mobile,
                            //     country_code: country?.countryCode,
                            //   }));
                            // }}
                            />
                            {/* {newOrgFlag &&
                              (company?.mobile_number === "" ||
                                company?.mobile_number === null) && (
                                <Label
                                  title="Please enter mobile number"
                                  modeError={true}
                                ></Label>
                              )} */}
                          </Col>
                        </Row>
                        <div className="d-flex justify-content-end">
                          <Button
                            className="btn btn-brand w-100 mt-4"
                            id="add-new"
                            onClick={() => {
                              // if (selectedOrgUUID === "")
                              handleSaveNewOrganization();
                              // else handleUpdateOrganization();
                            }}
                          >
                            Save
                          </Button>
                        </div>
                      </Card.Body>
                    </Card>
                  </Form>
                )
              )}
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
};
export default SelectOrganization;
